module.exports = __webpack_public_path__ + "static/media/company_default.0a5bb305.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/company_default.png
// module id = 2436
// module chunks = 0